export default __webpack_public_path__ + "static/media/cover.bf6449f6.jpg";